<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>

<template>
  <button class="flex cursor-pointer items-center justify-center">
    <span class="hidden md:mr-2.5 md:block">{{ title }}</span>
    <span class="flex size-8 items-center justify-center rounded-full bg-white"><SvgIcon name="outlined/east" /></span>
  </button>
</template>
